var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16482 1.04995C0.978565 1.23731 0.874023 1.49076 0.874023 1.75495C0.874023 2.01913 0.978565 2.27258 1.16482 2.45995L4.70482 6.04995L1.16482 9.58995C0.978565 9.77731 0.874023 10.0308 0.874023 10.2949C0.874023 10.5591 0.978565 10.8126 1.16482 10.9999C1.25778 11.0937 1.36838 11.1681 1.49024 11.2188C1.6121 11.2696 1.7428 11.2957 1.87482 11.2957C2.00683 11.2957 2.13753 11.2696 2.25939 11.2188C2.38125 11.1681 2.49185 11.0937 2.58482 10.9999L6.82482 6.75995C6.91854 6.66698 6.99294 6.55638 7.04371 6.43452C7.09448 6.31267 7.12061 6.18196 7.12061 6.04995C7.12061 5.91794 7.09448 5.78723 7.04371 5.66537C6.99294 5.54351 6.91854 5.43291 6.82482 5.33995L2.58482 1.04995C2.49185 0.95622 2.38125 0.881825 2.25939 0.831057C2.13753 0.780288 2.00683 0.754148 1.87482 0.754148C1.7428 0.754148 1.6121 0.780288 1.49024 0.831057C1.36838 0.881825 1.25778 0.95622 1.16482 1.04995Z",
    fill: "#000348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.e59665d953888bcc75c860b614a627ad.svg";
export { ForwardRef as ReactComponent };